<template>
  <div>
    <Navbar></Navbar>
    <main>
      <div class="container">
        <div class="settings-message" :style="{ opacity: showAlert ? 1 : 0}">
          <span class="alert alert-success">Public draw settings updated.</span>
        </div>
        <div class="row">
          <div class="col-12 d-flex align-items-center page-header">
            <a class="header-action" @click="goToDashboard()">
              <img class="header-action back" src="@/assets/images/x.svg">
            </a>
            <h1>PUBLIC DRAW SETTINGS</h1>
            <div class="desktop">
              <button
                :disabled="this.waitSave"
                class="btn btn-primary save"
                @click="saveSettings"
              >Save</button>
            </div>
          </div>
          <div class="col-12 d-flex">
            <div class="title">
              <p>Show/Hide on Public Draw screen</p>
              <label class="check-container">
                <input type="checkbox" :checked="this.prize" @change="handlePrizeCheck">
                <b class="label-text">Prize Name</b>
                <span class="checkmark"/>
              </label>
              <label class="check-container">
                <input type="checkbox" :checked="winner" @change="handleWinnerCheck">
                <b class="label-text">Winner Position</b>
                <span class="checkmark"/>
              </label>
              <label class="check-container">
                <input type="checkbox" :checked="this.spin" @change="handleSpinCheck">
                <b class="label-text">Spin/Skip Buttons</b>
                <span class="checkmark"/>
              </label>
              <div v-if="!this.spin" class="spin-instructions">
                <p>Button Guide: </p>
                  <ul>
                    <li><p><b>Escape</b>: Cancels Draw</p></li>
                    <li><p><b>Space Bar</b>: Starts Draw</p></li>
                    <li><p><b>A</b>: Skips Draw</p></li>
                    <li><p><b>S</b>: Respins Current Draw</p></li>
                    <li><p><b>D</b>: Moves On Current Winner</p></li>
                    <li><p><b>C</b>: Confirms Winner</p></li>
                  </ul>
              </div>
            </div>
          </div>
          <div class="col-12 d-flex">
            <div class="title">
              <p>
                Upload Custom Background Image
                <span class="change-btn-wrapper">
                  <a>change</a>
                  <input type="file" accept="image/*" @change="previewBgImage">
                </span>
              </p>

              <div v-if="backgroundUrl === ''" class="upload-btn-wrapper">
                <button class="upload-btn">+</button>
                <input type="file" accept="image/*" @change="previewBgImage">
              </div>

              <div v-else>
                <!-- <b class="uploaded-image"> {{image1Name}}</b> -->
                <b class="uploaded-image">{{backgroundUrl}}</b>
              </div>
              <div
                class="image-upload-text"
              >*Please upload an image which is at least 1280 px X 800 px in dimension. Max file upload size is 4MB
                <br>**supported formats are .jpg and .png
              </div>
            </div>
          </div>
          <div class="col-12 d-flex">
            <div class="title">
              <p>
                Upload Custom Image for Thank you Page
                <span class="change-btn-wrapper">
                  <a>change</a>
                  <input type="file" accept="image/jpeg, image/png" @change="previewThankImage">
                </span>
              </p>

              <div v-if="thankyouUrl === ''" class="upload-btn-wrapper">
                <button class="upload-btn">+</button>
                <input type="file" accept="image/jpeg, image/png" @change="previewThankImage">
              </div>
              <div v-else>
                <!-- <b class="uploaded-image"> {{image2Name}}</b> -->
                <b class="uploaded-image">{{thankyouUrl}}</b>
              </div>
              <div
                class="image-upload-text"
              >*Please upload an image which is at least 1280 px X 800 px in dimension. Max file upload size is 4MB
                <br>**supported formats are .jpg and .png
              </div>
            </div>
          </div>
          <div class="col-12 d-flex">
            <div class="title">
              <p>Spinning Field (Spin Using)</p>
              <div class="spin-dropdown-container dropdown">
                <div data-toggle="dropdown">
                  <label
                    aria-haspopup="true"
                    aria-expanded="false"
                    class="form-control spinning-field-label"
                  >{{computedSpinningField}}</label>
                  <span class="caret-container">
                    <img src="@/assets/images/caret.svg">
                  </span>
                </div>
                <div class="dropdown-menu list-container" aria-labelledby="dropdownMenuButton">
                  <template v-for="(field,index) in allAttendeeFields">
                    <li
                      v-if="field.data_type === 'string'"
                      :key="index"
                      @click="chooseItem(field)"
                    >{{field.label}}</li>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mobile">
          <button :disabled="this.waitSave" class="btn btn-primary save" @click="saveSettings">Save</button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import axios from "axios";
import Upload from "@/ext/upload";
import toastr from "toastr";
export default {
  name: "PublicDrawSettings",
  data() {
    return {
      eventId: "",
      imageBgData: "",
      imageThankData: "",
      image1Name: "",
      image2Name: "",
      activeItem: "",
      showMenu: false,
      eventSettings: {},
      prize: false,
      winner: false,
      spin: false,
      backgroundUrl: "",
      thankyouUrl: "",
      showAlert: false,
      allAttendeeFields: [
        { label: "Name", name: "name", data_type: "string" },
        { label: "E-Mail", name: "email", data_type: "string" },
        { label: "Attendee #", name: "attendee_no", data_type: "string" },
        { label: "Ticket #", name: "ticket_no", data_type: "string" }
      ],
      waitSave: false
    };
  },
  components: { Navbar },
  computed: {
    visibilityStr() {
      return `${this.prize ? "1" : "0"}${this.winner ? "1" : "0"}${
        this.spin ? "1" : "0"
      }`;
    },
    computedSpinningField() {
      let label = "";

      if (this.allAttendeeFields.length > 0) {
        let filteredLabel = this.allAttendeeFields.filter(
          field => field.name === this.activeItem
        );
        if (filteredLabel.length > 0) {
          label = filteredLabel[0]["label"];
        }
      }
      return label;
    }
  },
  methods: {
    handlePrizeCheck: function(event) {
      this.prize = !this.prize;
    },
    goToDashboard() {
      this.$router.push("/");
    },
    saveSettings: function() {
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                  mutation {
                    updateSetting(eventId: "${this.eventId}",
                    backgroundUrl: "${this.backgroundUrl}",
                    thankyouImageUrl: "${this.thankyouUrl}",
                    visibility: "${this.visibilityStr}",
                    spinningField: "${this.activeItem}"
                    ) {
                      id
                      eventId
                      backgroundUrl
                      thankyouImageUrl
                      visibility
                      spinningField
                    }
                  }
                `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            if (response.status == 200) {
              this.showAlert = true;
              setTimeout(() => {
                this.showAlert = false;
              }, 3000);
            }
          }.bind(this)
        );
    },
    handleWinnerCheck: function(event) {
      this.winner = !this.winner;
    },
    handleSpinCheck: function(event) {
      this.spin = !this.spin;
    },
    previewBgImage: function(event) {
      var input = event.target;

      this.image1Name = input.files[0].name;

      var reader = new FileReader();
      var file = event.target.files[0];

      if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
        if (file.size <= 4000000) {
          this.waitSave = true;
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            Upload(file.name, file.type, reader.result, response => {
              if (response) {
                this.backgroundUrl = response;
                this.waitSave = false;
              } else {
                this.waitSave = false;
              }
            });
          };
        } else {
          toastr.options.positionClass = "toast-bottom-right";
          toastr.error(
            "Please upload a file which is less than or equal to 4MB."
          );
        }
      } else {
        toastr.options.positionClass = "toast-bottom-right";
        toastr.error(
          "Invalid file type. Only files of type .png or .jpeg are allowed."
        );
      }
    },
    previewThankImage: function(event) {
      var input = event.target;

      this.image2Name = input.files[0].name;

      var reader = new FileReader();
      var file = event.target.files[0];

      if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
        if (file.size <= 4000000) {
          this.waitSave = true;
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            Upload(file.name, file.type, reader.result, response => {
              if (response) {
                this.thankyouUrl = response;
                this.waitSave = false;
              } else {
                this.waitSave = false;
              }
            });
          };
        } else {
          toastr.options.positionClass = "toast-bottom-right";
          toastr.error(
            "Please upload a file which is less than or equal to 4MB."
          );
        }
      } else {
        toastr.options.positionClass = "toast-bottom-right";
        toastr.error(
          "Invalid file type. Only files of type .png or .jpeg are allowed."
        );
      }
    },
    chooseItem: function(field) {
      this.activeItem = field.name;
    }
  },
  async mounted() {
    this.eventId = localStorage.getItem("event_id");
    try {
      let getEventSettings = await axios.post(window.ENDPOINT, {
        query: `query {
                  eventSettings(eventId: "${this.eventId}") {
                    id
                    eventId
                    spinningField
                    backgroundUrl
                    thankyouImageUrl
                    visibility
                    createdAt
                    updatedAt
                  }
                }`
      });
      if (getEventSettings) {
        this.eventSettings = getEventSettings.data.data.eventSettings;
        let array = this.eventSettings.visibility.split("");
        if (array[0] == "1") {
          this.prize = true;
        }
        if (array[1] == "1") {
          this.winner = true;
        }
        if (array[2] == "1") {
          this.spin = true;
        }
        this.activeItem = this.eventSettings.spinningField;
        this.backgroundUrl = this.eventSettings.backgroundUrl;
        this.thankyouUrl = this.eventSettings.thankyouImageUrl;
      }
    } catch (error) {
      console.log(error);
    }

    let attendeeFieldsApi = await axios.post(
      window.ENDPOINT,
      {
        query: `query {
            attendeeFields(eventId:"${this.eventId}")
          }`
      },
      {
        headers: {
          Authorization: localStorage.getItem("gevme_token")
        }
      }
    );

    if (attendeeFieldsApi && attendeeFieldsApi.status === 200) {
      attendeeFieldsApi.data.data.attendeeFields.pages.forEach(page => {
        page.fields.forEach(field => {
          this.allAttendeeFields.push(field);
        });
      });
    }
  }
};
</script>

<style scoped>
.container {
  position: relative;
}
.settings-message {
  position: absolute;
  width: 100%;
  text-align: center;
  top: -50px;
  transition: opacity 0.35s;
}
.settings-message .alert {
  padding: 0.075rem 1rem;
}

.header-action.back {
  /* width: 22px;
  height: 14px; */
}

button.save {
  margin-left: 150px;
  padding: 11px 60px;
}

div.title p {
  font-size: 18px;
  font-weight: 600;
  color: #323c48;
  margin-top: 27px;
}

.change-btn-wrapper a {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
  font-size: 14px;
}

label.check-container {
  display: block;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

label.check-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

span.checkmark {
  position: absolute;
  top: 2px;
  left: 0;
  height: 19px;
  width: 19px;
  border-radius: 50%;
  border: solid 1px #0088ff;
  background: transparent;
}

label.check-container input:checked ~ .checkmark {
  background-color: #0088ff;
  border: none !important;
}

label.spinning-field-label {
  cursor: pointer;
}

span.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

label.check-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
label.check-container .checkmark:after {
  left: 7px;
  top: 3.5px;
  width: 4px;
  height: 9px;
  border: solid white;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.label-text {
  font-weight: 400;
  font-size: 16px;
  color: #323c48;
  margin-left: 9px;
}

.upload-btn-wrapper,
.change-btn-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.upload-btn-wrapper .upload-btn {
  border: 1px dashed #323c48;
  color: #0088ff;
  background-color: white;
  padding: 0px 13px;
  font-size: 30px;
  font-weight: bold;
  cursor: pointer;
}

.upload-btn-wrapper .upload-btn:active,
.upload-btn-wrapper .upload-btn:focus,
.upload-btn-wrapper .upload-btn:hover,
.upload-btn-wrapper .upload-btn::selection {
  background: transparent;
  outline: none;
}

.upload-btn-wrapper b {
  font-size: 12px;
  color: rgba(50, 60, 72, 0.62);
  font-weight: 400;
  position: relative;
  bottom: 25px;
  left: 10px;
}

.upload-btn-wrapper input[type="file"],
.change-btn-wrapper input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;

  padding: 10px;
  width: 45px;
  cursor: pointer;
}

.caret-container {
  display: flex;
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
}
.spin-dropdown-container {
  position: relative;
  width: 396px;
  height: 43px;
  max-width: 92vw;
}
.caret-container > img {
  width: 14px;
  height: 9px;
  transform: rotate(180deg);
}

.list-container {
  width: inherit;
  cursor: pointer;
  background-color: #fbfcfc;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
  max-height: 300px;
  overflow-y: auto;
}

.list-container li:hover {
  background-color: #f1f2f4;
}
li {
  padding: 10px 0 6px 24px;
  cursor: pointer;
}

.uploaded-image {
  color: #323c48;
  font-size: 16px;
  background-color: #f1f2f4;
  padding: 2px 5px 2px 7px;
  font-weight: 400;
}

.image-upload-text {
  font-size: 14px;
  margin-top: 10px;
}
.mobile {
  display: none;
}

.spin-instructions {
  margin-top: 10px;
  background-color: #f1f2f4;
  padding: 20px;
}
.spin-instructions ul {
  margin-bottom: 0;
}
.spin-instructions p {
  font-size: 12px !important;
  margin: 0 !important;
}
.spin-instructions li {
  padding: 0;
}

.mobile button.save {
  margin-left: 0;
  margin-top: 20px;
}
@media screen and (max-width: 991px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}

@media screen and (max-width: 640px) {
  .page-header a.header-action {
    left: 14px;
  }

  .page-header {
    padding-left: 50px;
  }
}

@media screen and (min-width: 992px) and (max-width: 1024px) {
  .page-header a.header-action {
    left: 0;
  }

  .page-header {
    padding-left: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PublicDrawSettings.vue